// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__1z3wf","tab":"ProcedureTabs_tab___VOZB"};